var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.daemon)?_c('span',{staticClass:"app-daemon-badge",attrs:{"title":_vm.daemon.name}},[_c(_setup.NcIconSvgWrapper,{attrs:{"path":_setup.mdiFileChart,"size":20,"inline":""}}),_vm._v("\n\t"+_vm._s(_vm.daemon.display_name)+"\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }